import { CDN2 } from '@/helpers/api';
import useGoogleMaps from '@/hooks/useGoogleMaps';
import { Circle, GoogleMap, Marker } from '@react-google-maps/api';

export default function ParkingAtMap({ facility }) {
  const isLoaded = useGoogleMaps();
  const lat = facility.facility_latitude_fake;
  const lng = facility.facility_longitude_fake;
  return (
    isLoaded && (
      <>
        <div className="flex flex-col h-98 md:h-full md:min-h-fit">
          <GoogleMap
            zoom={
              facility.facilityParkingType === 1 ||
              facility.facilityParkingType === 2
                ? 15
                : 10
            }
            id="google-map-parking-at"
            mapContainerStyle={{
              height: '100%',
              width: '100%',
            }}
            center={{
              lat: lat,
              lng: lng,
            }}
            options={{
              disableDefaultUI: true,
              zoomControl: true,
              zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
              },
            }}
          >
            <Marker
              position={{
                lat: lat,
                lng: lng,
              }}
              animation={google.maps.Animation.DROP}
              icon={{
                url: CDN2() + '/staticmyapp/pat-pin.svg',
                scaledSize: new google.maps.Size(30, 41),
                anchor: new google.maps.Point(15, 30),
              }}
            />
            <Circle
              center={{
                lat: parseFloat(lat),
                lng: parseFloat(lng),
              }}
              radius={
                facility.facilityParkingType === 1 ||
                facility.facilityParkingType === 2
                  ? 175
                  : 6000
              }
              options={{
                strokeColor: '#F37621',
                strokeOpacity: 1,
                strokeWeight: 1.5,
                fillColor: '#F37621',
                fillOpacity: 0.1,
                clickable: false,
              }}
            />
          </GoogleMap>
          {/* <p className="bg-gray-100 p-2">* Approximate Location</p> */}
        </div>
      </>
    )
  );
}
